import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Link } from "react-scroll";
import LoginButton from "../Login/LoginButton";
import LogoutButton from "../Login/Logoutbutton";
import styles from "./Header.module.css"
import { useAuth0 } from "@auth0/auth0-react";


const Header = () => {
  const [icon, setIcon] = useState(() => false);

  // Add a state to keep track of the active section
  const [activeSection, setActiveSection] = useState("home_p"); // Assuming section1 is the initial active section

  const { isAuthenticated } = useAuth0();

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  // Function to handle scrolling and update active section
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const section1Height = document.getElementById("home_p")?.clientHeight || 0;
    const section2Height = document.getElementById("body_p")?.clientHeight || 0;
    const section3Height =
      document.getElementById("about_p")?.clientHeight || 0;

    if (scrollPosition < section1Height) {
      setActiveSection("home_p");
    } else if (
      scrollPosition >= section1Height &&
      scrollPosition < section1Height + section2Height
    ) {
      setActiveSection("body_p");
    } else if (
      scrollPosition >= section1Height + section2Height &&
      scrollPosition < section1Height + section2Height + section3Height
    ) {
      setActiveSection("about_p");
    }
  };

  // Attach the handleScroll function to the scroll event
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const iconHandler = () => {
    setIcon((prevIcon) => !prevIcon);
  };

  const closeDropdown = () => {
    setIcon(false);
  };

  const naValue = icon ? `${styles} fa fa-times` : `${styles} fa fa-bars`;

  return (
    <header>
      <div id={styles.navbar} className={icon ? styles.active : undefined}>
        <div className={styles.logo}>
          <NavLink exact to="/">
            Schedule App
          </NavLink>
        </div>
        <div id={styles.navList} className={icon ? styles.active : undefined}>
          <ul>
            <li>
              {isHomePage ? (
                <Link
                  className={`${styles.head_btn} ${
                    activeSection === "home_p" ? styles["active-link"] : ""
                  }`}
                  activeClass="active"
                  to="home_p"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                >
                  Home
                </Link>
              ) : (
                <NavLink exact to="/" className={styles.head_btn}>
                  Home
                </NavLink>
              )}
            </li>

            <li>
              <NavLink className={styles.head_btn} to="/schedule">
                Individual
              </NavLink>
            </li>
            <li>
              <NavLink className={styles.head_btn} to="/schedule">
                Team
              </NavLink>
            </li>
            {isHomePage && (
              <>
                <li>
                  <Link
                    className={`${styles.head_btn} ${
                      activeSection === "body_p" ? styles["active-link"] : ""
                    }`}
                    activeClass="active"
                    to="body_p"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${styles.head_btn} ${
                      activeSection === "about_p" ? styles["active-link"] : ""
                    }`}
                    activeClass="active"
                    to="about_p"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                  >
                    Contact
                  </Link>
                </li>
              </>
            )}
            <li>
              {isAuthenticated ? (
                <LogoutButton
                  buttonText="Log Out"
                  className={styles.action_btn} // Pass the className
                  closeDropdown={closeDropdown}
                />
              ) : (
                <LoginButton
                  buttonText="Get Started"
                  buttonStyle={styles.action_btn}
                  closeDropdown={closeDropdown}
                />
              )}
            </li>
          </ul>
        </div>
        <div id={styles.toggle_btn} onClick={iconHandler}>
          <i className={naValue}></i>
        </div>
      </div>
      <div
        className={`${styles.dropdown_menu} ${icon ? styles.open : undefined}`}
      >
        <ul className={styles.links}>
          <li>
            {isHomePage ? (
              <Link
                onClick={closeDropdown}
                activeClass="active"
                to="home_p"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
                className={styles.home}
              >
                Home
              </Link>
            ) : (
              <NavLink
                exact
                to="/"
                onClick={closeDropdown}
                className={styles.home}
              >
                Home
              </NavLink>
            )}
          </li>

          <li>
            <NavLink to="/schedule" onClick={closeDropdown}>
              Individual
            </NavLink>
          </li>
          <li>
            <NavLink to="/schedule" onClick={closeDropdown}>
              Team
            </NavLink>
          </li>
          {isHomePage && (
            <>
              <li>
                <Link
                  onClick={closeDropdown}
                  activeClass="active"
                  to="about"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  onClick={closeDropdown}
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                >
                  Contact
                </Link>
              </li>
            </>
          )}
          <li>
            {isAuthenticated ? (
              <LogoutButton
                buttonText="Log Out"
                className={styles.action_btn} // Pass the className
                closeDropdown={closeDropdown}
              />
            ) : (
              <LoginButton
                buttonText="Get Started"
                buttonStyle={styles.action_btn}
                closeDropdown={closeDropdown}
              />
            )}
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
